import React, { useState, useRef, useEffect } from "react";

const RecentSearches: React.FC<{
    searches: string[];
    onClick: (item: string) => void;
}> = ({ searches, onClick }) => {
    const [containerHeight, setContainerHeight] = useState("auto");
    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);

    // 监听容器变化并更新高度
    useEffect(() => {
        if (contentRef.current) {
            const updateHeight = () => {
                if (!contentRef.current) return;
                const contentHeight = contentRef.current.scrollHeight;
                const maxHeight = 140;

                setContainerHeight(Math.min(contentHeight, maxHeight) + "px");
            };

            // 初始更新
            updateHeight();

            // 创建 ResizeObserver 以响应容器大小变化
            const resizeObserver = new ResizeObserver(updateHeight);
            resizeObserver.observe(contentRef.current);

            return () => resizeObserver.disconnect();
        }
    }, []);

    return (
        <div className="w-full px-4">
            <div
                ref={containerRef}
                style={{ height: containerHeight }}
                className={`overflow-hidden transition-[height] duration-300 ease-in-out`}
            >
                <div ref={contentRef} className={`flex flex-wrap gap-1.5`}>
                    {searches.map((term, index) => {
                        return (
                            <button
                                key={index}
                                onClick={() => onClick(term)}
                                className="h-7 px-3 py-1 bg-bg_1 hover:bg-bg_2 rounded-full text-text_2 text-body3 transition-colors duration-200 ease-in-out"
                            >
                                {term.length > 15
                                    ? `${term.slice(0, 4)}...${term.slice(term.length - 4, term.length)}`
                                    : term}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default RecentSearches;
